(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("VoiceInputController", VoiceInputController);

    VoiceInputController.$inject = [
        "$scope",
        "VoiceInputService",
        "$log",
        "$uibModal",
        "$window",
        "systemConstants",
        "$compile",
        "$templateRequest",
        "$document",
        "$interval",
        "$translate",
        "$timeout",
        "toastr",
        "voiceInputConstants"
    ];

    function VoiceInputController(
        $scope,
        VoiceInputService,
        $log,
        $uibModal,
        $window,
        systemConstants,
        $compile,
        $templateRequest,
        $document,
        $interval,
        $translate,
        $timeout,
        toastr,
        voiceInputConstants
    ) {
        var vm = this;

        vm.isRecording = false;
        vm.isProcessing = false;
        vm.processMode = null; // 'ia' | 'transcribe' | null
        vm.contextPrompt = vm.contextPrompt || null;
        vm.toggleRecording = toggleRecording;
        vm.openModeSelector = openModeSelector;
        vm.openModeDrawer = openModeDrawer;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;

        function toggleRecording() {
            if (!vm.isRecording) {
                if (vm.allowGeneration) {
                    if (vm.isMobile) {
                        openModeDrawer();
                    } else {
                        openModeSelector();
                    }
                } else {
                    vm.processMode = vm.contextPrompt ? voiceInputConstants.VOICE.AI : voiceInputConstants.VOICE.TRANSCRIBE;
                    startRecording();
                }
            } else {
                stopRecording();
            }
        }

        function openModeDrawer() {
            createAndShowDrawer(
                "app/shared/directives/voice-input/templates/mode-selector-drawer.html",
                function (drawerScope, closeDrawer) {
                    drawerScope.phase = voiceInputConstants.VOICE.CHOOSE; // choose | recording | processing
                    drawerScope.elapsedSeconds = voiceInputConstants.TIME.ELAPSED_SECONDS_INIT;
                    drawerScope.maxSeconds = voiceInputConstants.TIME.MAX_SECONDS;
                    drawerScope.progressPercent = voiceInputConstants.TIME.PROGRESS_PERCENT_INIT;
                    var progressTimer = null;

                    function startProgress() {
                        stopProgress();
                        progressTimer = $interval(function () {
                            drawerScope.elapsedSeconds += voiceInputConstants.TIME.ELAPSED_SECONDS_INTERVAL;
                            if (
                                drawerScope.elapsedSeconds >
                                drawerScope.maxSeconds
                            ) {
                                drawerScope.elapsedSeconds =
                                    drawerScope.maxSeconds;
                                drawerScope.$applyAsync
                                    ? drawerScope.$applyAsync()
                                    : null;
                                drawerScope.sendAudio();
                            }
                            drawerScope.progressPercent =
                                (drawerScope.elapsedSeconds /
                                    drawerScope.maxSeconds) *
                                100;
                        }, 200);
                    }

                    function stopProgress() {
                        if (progressTimer) {
                            $interval.cancel(progressTimer);
                            progressTimer = null;
                        }
                    }

                    drawerScope.formatTime = function (seconds) {
                        var s = Math.floor(seconds);
                        var m = Math.floor(s / 60);
                        var rem = s % 60;
                        return m + ":" + (rem < 10 ? "0" + rem : rem);
                    };

                    drawerScope.selectMode = function (mode) {
                        vm.processMode = mode === voiceInputConstants.VOICE.AI ? voiceInputConstants.VOICE.AI : voiceInputConstants.VOICE.TRANSCRIBE;
                        if (vm.processMode === voiceInputConstants.VOICE.AI && !vm.contextPrompt) {
                            vm.contextPrompt = voiceInputConstants.VOICE.GENERAL;
                        }

                        // start recording without closing drawer
                        navigator.mediaDevices
                            .getUserMedia({ audio: true })
                            .then(function (stream) {
                                drawerScope.phase = voiceInputConstants.VOICE.RECORDING;
                                drawerScope.elapsedSeconds = voiceInputConstants.TIME.ELAPSED_SECONDS_INIT;
                                drawerScope.progressPercent = voiceInputConstants.TIME.PROGRESS_PERCENT_INIT;
                                startProgress();
                                vm.isRecording = true;
                                return VoiceInputService.startRecording(stream);
                            })
                            .catch(function (err) {
                                $log.error("Erro ao acessar o microfone:", err);
                                closeDrawer();
                                if (
                                    err.name ===  voiceInputConstants.ERROR.NOT_ALLOWED_ERROR ||
                                    err.name === voiceInputConstants.ERROR.PERMISSION_DENIED_ERROR
                                ) {
                                    showMicrophonePermissionError();
                                } else if (
                                    err.name === voiceInputConstants.ERROR.NOT_FOUND_ERROR ||
                                    err.name === voiceInputConstants.ERROR.DEVICES_NOT_FOUND_ERROR
                                ) {
                                    showMicrophoneError(
                                        $translate.instant(
                                            "voiceInput.error.deviceNotFound"
                                        )
                                    );
                                } else if (
                                    err.name === voiceInputConstants.ERROR.NOT_READABLE_ERROR ||
                                    err.name === voiceInputConstants.ERROR.TRACK_START_ERROR
                                ) {
                                    showMicrophoneError(
                                        $translate.instant(
                                            "voiceInput.error.deviceInUse"
                                        )
                                    );
                                } else {
                                    showMicrophoneError(
                                        $translate.instant(
                                            "voiceInput.error.access",
                                            { message: err.message }
                                        )
                                    );
                                }
                            });
                    };

                    drawerScope.sendAudio = function () {
                        if (drawerScope.phase !== voiceInputConstants.VOICE.RECORDING) {
                            return;
                        }
                        stopProgress();
                        drawerScope.phase = voiceInputConstants.VOICE.PROCESSING;
                        vm.isRecording = false;
                        vm.isProcessing = true;

                        VoiceInputService.stopRecording()
                            .then(function (audioBlob) {
                                if (vm.processMode ===  voiceInputConstants.VOICE.AI) {
                                    return VoiceInputService.sendAudioForTranscriptionGenerationIA(
                                        audioBlob,
                                        vm.contextPrompt ||  voiceInputConstants.VOICE.GENERAL
                                    );
                                }
                                return VoiceInputService.sendAudioForTranscription(
                                    audioBlob
                                );
                            })
                            .then(function (transcription) {
                                $scope.$applyAsync(function () {
                                    vm.ngModel = transcription;
                                    vm.isProcessing = false;
                                });
                                closeDrawer();
                            })
                            .catch(function (err) {
                                $log.error("Erro ao processar áudio:", err);
                                toastr.error(
                                    $translate.instant(
                                        "voiceInput.error.transcribeAudio"
                                    )
                                );
                                $scope.$applyAsync(function () {
                                    vm.isProcessing = false;
                                });
                                closeDrawer();
                            })
                            .finally(function () {
                                stopProgress();
                            });
                    };

                    drawerScope.$on("$destroy", function () {
                        stopProgress();
                    });

                    // Executa antes de fechar o drawer para cancelar gravação sem enviar
                    drawerScope.beforeClose = function () {
                        stopProgress();
                        if (vm.isRecording) {
                            try {
                                VoiceInputService.stopRecording();
                            } catch (e) {
                                $log.debug(
                                    "Erro ao cancelar gravação (drawer)",
                                    e
                                );
                            }
                        }
                        vm.isRecording = false;
                        vm.isProcessing = false;
                    };
                }
            );
        }

        function checkError(err) {
            if (
                err.name === voiceInputConstants.ERROR.NOT_ALLOWED_ERROR ||
                err.name === voiceInputConstants.ERROR.PERMISSION_DENIED_ERROR
            ) {
                showMicrophonePermissionError();
            } else if (
                err.name === voiceInputConstants.ERROR.NOT_FOUND_ERROR ||
                err.name === voiceInputConstants.ERROR.DEVICES_NOT_FOUND_ERROR
            ) {
                showMicrophoneError(
                    $translate.instant('voiceInput.error.deviceNotFound'));
            } else if (
                err.name === voiceInputConstants.ERROR.NOT_READABLE_ERROR ||
                err.name === voiceInputConstants.ERROR.TRACK_START_ERROR
            ) {
                showMicrophoneError(
                    $translate.instant('voiceInput.error.deviceInUse'));
            } else {
                showMicrophoneError(
                    $translate.instant('voiceInput.error.access') +
                    err.message
                );
            }
        }

        function openModeSelector() {
            $uibModal.open({
                animation: true,
                templateUrl:
                    "app/shared/directives/voice-input/templates/mode-selector-modal.html",
                controller: [
                    "$scope",
                    "$interval",
                    "$uibModalInstance",
                    "VoiceInputService",
                    "parentVm",
                    "$timeout",
                    function (
                        $modalScope,
                        $modalInterval,
                        $uibModalInstance,
                        VoiceInputService,
                        parentVm,
                        $timeout
                    ) {
                        var vm = this;
                        vm.phase =  voiceInputConstants.VOICE.CHOOSE;
                        vm.elapsedSeconds = voiceInputConstants.TIME.ELAPSED_SECONDS_INIT;
                        vm.maxSeconds = voiceInputConstants.TIME.MAX_SECONDS;
                        vm.progressPercent = voiceInputConstants.TIME.PROGRESS_PERCENT_INIT;
                        var modalTimer = null;

                        function startProgress() {
                            stopProgress();
                            modalTimer = $modalInterval(function () {
                                vm.elapsedSeconds += voiceInputConstants.TIME.ELAPSED_SECONDS_INTERVAL;
                                if (vm.elapsedSeconds > vm.maxSeconds) {
                                    vm.elapsedSeconds = vm.maxSeconds;
                                    vm.sendAudio();
                                }
                                vm.progressPercent =
                                    (vm.elapsedSeconds / vm.maxSeconds) * 100;
                            }, 200);
                        }

                        function stopProgress() {
                            if (modalTimer) {
                                $modalInterval.cancel(modalTimer);
                                modalTimer = null;
                            }
                        }

                        vm.formatTime = function (seconds) {
                            var s = Math.floor(seconds);
                            var m = Math.floor(s / 60);
                            var rem = s % 60;
                            return m + ":" + (rem < 10 ? "0" + rem : rem);
                        };

                        vm.selectMode = function (mode) {
                            vm.processMode =
                                mode ===  voiceInputConstants.VOICE.AI ?  voiceInputConstants.VOICE.AI :  voiceInputConstants.VOICE.TRANSCRIBE;
                            if (vm.processMode ===  voiceInputConstants.VOICE.AI && !vm.contextPrompt) {
                                vm.contextPrompt =  voiceInputConstants.VOICE.GENERAL;
                            }
                            navigator.mediaDevices
                                .getUserMedia({ audio: true })
                                .then(function (stream) {
                                    vm.phase =  voiceInputConstants.VOICE.RECORDING;
                                    vm.elapsedSeconds = voiceInputConstants.TIME.ELAPSED_SECONDS_INIT;
                                    vm.progressPercent = voiceInputConstants.TIME.PROGRESS_PERCENT_INIT;
                                    startProgress();
                                    vm.isRecording = true;
                                    parentVm.isRecording = true;
                                    return VoiceInputService.startRecording(
                                        stream
                                    );
                                })
                                .catch(function (err) {
                                    $log.error(
                                        "Erro ao acessar o microfone:",
                                        err
                                    );
                                    $uibModalInstance.dismiss(
                                        "permission_error"
                                    );
                                    checkError(err);
                                });
                        };

                        vm.sendAudio = function () {
                            if (vm.phase !== voiceInputConstants.VOICE.RECORDING) {
                                return;
                            }
                            stopProgress();
                            vm.phase = voiceInputConstants.VOICE.PROCESSING;
                            vm.isRecording = false;
                            vm.isProcessing = true;
                            parentVm.isRecording = false;
                            parentVm.isProcessing = true;
                            VoiceInputService.stopRecording()
                                .then(function (audioBlob) {
                                    if (vm.processMode === voiceInputConstants.VOICE.AI) {
                                        return VoiceInputService.sendAudioForTranscriptionGenerationIA(
                                            audioBlob,
                                            vm.contextPrompt || voiceInputConstants.VOICE.GENERAL
                                        );
                                    }
                                    return VoiceInputService.sendAudioForTranscription(
                                        audioBlob
                                    );
                                })
                                .then(function (transcription) {
                                    var textResult =
                                        angular.isDefined(transcription) &&
                                        transcription !== null
                                            ? String(transcription)
                                            : "";
                                    $scope.$applyAsync(function () {
                                        vm.ngModel = textResult;
                                        parentVm.ngModel = textResult;
                                        vm.isProcessing = false;
                                        parentVm.isProcessing = false;
                                        $uibModalInstance.close();
                                    });
                                })
                                .catch(function (err) {
                                    $log.error("Error processing audio:", err);
                                    toastr.error(
                                        $translate.instant(
                                            "voiceInput.error.transcribeAudio"
                                        )
                                    );
                                    $scope.$applyAsync(function () {
                                        vm.isProcessing = false;
                                        parentVm.isProcessing = false;
                                    });
                                    $uibModalInstance.dismiss("error");
                                })
                                .finally(function () {
                                    stopProgress();
                                });
                        };

                        $modalScope.$on("$destroy", function () {
                            // When closing the modal, cancel the recording without sending
                            stopProgress();
                            if (vm.isRecording || parentVm.isRecording) {
                                try {
                                    VoiceInputService.stopRecording();
                                } catch (e) {
                                    $log.debug(
                                        "Erro ao cancelar gravação (modal)",
                                        e
                                    );
                                }
                            }
                            parentVm.isRecording = false;
                            parentVm.isProcessing = false;
                            vm.isRecording = false;
                            vm.isProcessing = false;
                        });
                    },
                ],
                controllerAs: "vm",
                resolve: {
                    parentVm: function () {
                        return vm;
                    },
                },
                size: "md",
                appendTo: angular.element($document[0].body),
                windowClass: "voice-choice-modal",
                backdropClass: "voice-choice-backdrop",
            });
        }

        function startRecording() {
            if (
                !navigator.mediaDevices ||
                !navigator.mediaDevices.getUserMedia
            ) {
                $log.error("Audio recording is not supported in this browser.");
                showMicrophoneError(
                    $translate.instant("voiceInput.error.browserNotSupported")
                );
                return;
            }

            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then(function (stream) {
                    vm.isRecording = true;
                    return VoiceInputService.startRecording(stream);
                })
                .catch(function (err) {
                    $log.error("Error accessing microphone:", err);

                    if (
                        err.name === voiceInputConstants.ERROR.NOT_ALLOWED_ERROR ||
                        err.name === voiceInputConstants.ERROR.PERMISSION_DENIED_ERROR
                    ) {
                        showMicrophonePermissionError();
                    } else if (
                        err.name === voiceInputConstants.ERROR.NOT_ALLOWED_ERROR ||
                        err.name === voiceInputConstants.ERROR.DEVICES_NOT_FOUND_ERROR
                    ) {
                        showMicrophoneError(
                            $translate.instant(
                                "voiceInput.error.deviceNotFound"
                            )
                        );
                    } else if (
                        err.name === voiceInputConstants.ERROR.NOT_READABLE_ERROR ||
                        err.name === voiceInputConstants.ERROR.TRACK_START_ERROR
                    ) {
                        showMicrophoneError(
                            $translate.instant("voiceInput.error.deviceInUse")
                        );
                    } else {
                        showMicrophoneError(
                            $translate.instant("voiceInput.error.access", {
                                message: err.message,
                            })
                        );
                    }
                });
        }

        function showMicrophonePermissionError() {
            if (vm.isMobile) {
                showMicrophonePermissionDrawer();
            } else {
                showMicrophonePermissionModal();
            }
        }

        function showMicrophonePermissionModal() {
            $uibModal.open({
                animation: true,
                templateUrl:
                    "app/shared/directives/voice-input/templates/microphone-permission-modal.html",
                size: "lg",
                appendTo: angular.element($document[0].body),
                windowClass: "voice-choice-modal",
                backdropClass: "voice-choice-backdrop",
            });
        }

        function showMicrophonePermissionDrawer() {
            createAndShowDrawer(
                "app/shared/directives/voice-input/templates/microphone-permission-drawer.html"
            );
        }

        function showMicrophoneError(message) {
            if (vm.isMobile) {
                showMicrophoneErrorDrawer(message);
            } else {
                showMicrophoneErrorModal(message);
            }
        }

        function showMicrophoneErrorModal(message) {
            $uibModal.open({
                animation: true,
                templateUrl:
                    "app/shared/directives/voice-input/templates/microphone-error-modal.html",
                controller: [
                    "message",
                    function (message) {
                        var vm = this;
                        vm.message = message;
                    },
                ],
                controllerAs: "vm",
                resolve: {
                    message: function () {
                        return message;
                    },
                },
                size: "md",
                appendTo: angular.element($document[0].body),
                windowClass: "voice-choice-modal",
                backdropClass: "voice-choice-backdrop",
            });
        }

        function showMicrophoneErrorDrawer(message) {
            createAndShowDrawer(
                "app/shared/directives/voice-input/templates/microphone-error-drawer.html",
                function (drawerScope) {
                    drawerScope.errorMessage = message;
                }
            );
        }

        function createAndShowDrawer(templateUrl, initializeScopeFn) {
            var childScope = $scope.$new(true);
            var drawerElement;

            function closeDrawer() {
                if (angular.isFunction(childScope.beforeClose)) {
                    try {
                        childScope.beforeClose();
                    } catch (e) {
                        $log.debug("Erro no beforeClose do drawer", e);
                    }
                }
                if (drawerElement) {
                    drawerElement.remove();
                }
                if (childScope) {
                    childScope.$destroy();
                }
            }

            childScope.closeDrawer = closeDrawer;

            if (angular.isFunction(initializeScopeFn)) {
                initializeScopeFn(childScope, closeDrawer);
            }

            $templateRequest(templateUrl).then(function (templateHtml) {
                var compiled = $compile(templateHtml)(childScope);
                angular.element($document[0].body).append(compiled);
                drawerElement = compiled;
            });

            return closeDrawer;
        }

        function stopRecording() {
            VoiceInputService.stopRecording()
                .then(function (audioBlob) {
                    vm.isRecording = false;
                    vm.isProcessing = true;
                    if (vm.allowGeneration) {
                        if (vm.processMode === voiceInputConstants.VOICE.AI) {
                            return VoiceInputService.sendAudioForTranscriptionGenerationIA(
                                audioBlob,
                                vm.contextPrompt || voiceInputConstants.VOICE.GENERAL
                            );
                        }
                        return VoiceInputService.sendAudioForTranscription(
                            audioBlob
                        );
                    }

                    if (vm.contextPrompt) {
                        return VoiceInputService.sendAudioForTranscriptionGenerationIA(
                            audioBlob,
                            vm.contextPrompt
                        );
                    }
                    return VoiceInputService.sendAudioForTranscription(
                        audioBlob
                    );
                })
                .then(function (transcription) {
                    $scope.$applyAsync(function () {
                        vm.ngModel = transcription;
                        vm.isProcessing = false;
                    });
                })
                .catch(function (err) {
                    $log.error("Erro ao processar áudio:", err);
                    toastr.error(
                        $translate.instant(
                            "voiceInput.error.transcribeAudio"
                        )
                    );
                    $scope.$applyAsync(function () {
                        vm.isRecording = false;
                        vm.isProcessing = false;
                    });
                });
        }

        $scope.$on("$destroy", function () {
            if (vm.isRecording) {
                stopRecording();
            }
        });
    }
})();
